<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center"
    content-class="relative flex flex-col w-3/4 h-3/4 mx-auto bg-white border rounded-lg"
  >
    <div class="p-6">
      <div class="pb-4 text-xl">Allocated Groups for Training Center</div>
      <div v-if="dataLoaded">
        <div class="grid grid-cols-2 gap-4" v-for="(item, id) in items" :key="id">
          <div v-if="!item.allocated_group_url" class="bold">{{ item.allocated_group }}</div>
          <div v-if="!item.allocated_group_url" class="bold">{{ item.organization }}</div>
          <a v-if="item.allocated_group_url" :href="item.allocated_group_url" class="value">{{ item.allocated_group }}</a>
          <a v-if="item.allocated_group_url" :href="item.organization_url" class="value">{{ item.organization }}</a>
        </div>
      </div>
      <button class="btn btn-secondary float-right" @click="closeModal()">Close</button>
      <div class="h-10">&nbsp;</div>
    </div>
  </VueFinalModal>
</template>

<script setup>
  import { VueFinalModal } from 'vue-final-modal'
  import { onMounted, ref } from 'vue'
  import axios from 'axios'

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['close'])

  let items = ref([{allocated_group: 'Allocated Group', organization: 'Organization'}])
  let dataLoaded = ref(false)

  onMounted(() => {
    requestReportingEntities()
  })

  function requestReportingEntities () {
    axios.get('/reporting_entities.json?ids=' + props.params.data.reporting_entity_ids.join(','))
      .then(rep => {
        console.log(rep.data)
        rep.data.forEach(ent => {
          items.value.push({
            allocated_group: ent.name,
            allocated_group_url: ent.url,
            organization: ent.organization.name,
            organization_url: ent.organization.url,
          })
        })

        dataLoaded.value = true
      })

      console.log(items.value)
  }

  function closeModal() {
    emit('close')
  }
</script>

<style lang="scss">
  .vm--modal {
    overflow: initial !important;
  }
  .info {
    padding: 10px;
    display: flex;
    flex-direction: row;
  }
  .bold {
    font-weight: bold;
  }
  .value {
    padding-left: 5px;
    @apply text-blue-600;
  }
</style>
